// DMapListComponent.jsx — only change: added [mapData] dep to useEffect
import {List, Spin, Card, Button} from 'antd';
import VirtualList from 'rc-virtual-list';
import {extractDateBySecond} from "../../../../utils";
import {CheckCircleOutlined, CloseCircleOutlined, FileExcelOutlined, FileProtectOutlined} from "@ant-design/icons";
import "./DMapListComponent.css";
import {useEffect} from "react";

const CONTAINER_HEIGHT = 600;

const DMapListComponent = ({mapData, loading, onItemClick}) => {
    // FIX: was missing dep array — ran on every render
    useEffect(() => {
        console.log(mapData);
    }, [mapData]);

    return (
        <List className="custom-list">
            <VirtualList
                data={mapData}
                height={CONTAINER_HEIGHT}
                itemHeight={120}
                itemKey={item => `list-item-${item.id}`}
                virtual={false}
            >
                {(item) => (
                    <List.Item key={`list-${item.id}`}>
                        <Card className="list-card" hoverable>
                            <p><strong>Company:</strong> {item.company__name}</p>
                            <p><strong>Market:</strong> {item.market__name}</p>
                            <p><strong>Serial:</strong> {item.device_serial_number}</p>
                            <p><strong>INN:</strong> {item.company__inn}</p>
                            <p>
                                <strong>Disconnected:</strong>{" "}
                                {item.is_disconnected ? (
                                    <FileProtectOutlined style={{color: "#05f71d"}}/>
                                ) : (
                                    <FileExcelOutlined style={{color: "#f44336"}}/>
                                )}
                            </p>
                            <p>
                                <strong>Is active:</strong>{" "}
                                {item.is_active ? (
                                    <CheckCircleOutlined style={{color: "#05f71d"}}/>
                                ) : (
                                    <CloseCircleOutlined style={{color: "#f44336"}}/>
                                )}
                            </p>
                            <p><strong>Updated time:</strong> {extractDateBySecond(item.updated_date)}</p>
                            <div className="card-actions">
                                <Button
                                    type="primary"
                                    size="small"
                                    onClick={() => window.open(`/device/detail/${item.device_serial_number}`, "_blank")}
                                >
                                    Detail
                                </Button>
                                <Button
                                    size="small"
                                    onClick={() => onItemClick?.(item)}
                                >
                                    Focus on Map
                                </Button>
                            </div>
                        </Card>
                    </List.Item>
                )}
            </VirtualList>

            {loading && (
                <div style={{textAlign: 'center', padding: 12}}>
                    <Spin/>
                </div>
            )}
        </List>
    );
};

export default DMapListComponent;